module.exports = "/_next/static/images/7d732604574287b87a55f9472f11ea26-perks-075x.jpg";